import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Button } from "../bootstrap/index.jsx";

export const Portal = ({ component: Component, className = "", ...props }) => {
  const el = React.useRef(document.createElement("div"));
  const body = document.querySelector("body");

  useEffect(() => {
    if (className) {
      el.current.classList.add(className);
    } 
    body.appendChild(el.current);
    return () => {
      body.removeChild(el.current);
    };
  }, []);

  return ReactDOM.createPortal(<Component {...props} />, el.current);
};

export const PortalTrigger = ({ label, btnElem = Button, btnProps = {}, portalProps = {}, defaultShow=false}) => {
  const [show, setShow] = useState(defaultShow);
  
  const {handleOnClick = null, ...rest} = btnProps;

  return (
    <>
      {React.createElement(btnElem, {
        ...rest,
        onClick: () => {
          if (handleOnClick) {
            handleOnClick(() => setShow(!show))
          } else {
            setShow(!show)
          }
        },
        children: label,
      })}
      {show ? <Portal {...portalProps} closeDialog={() => setShow(false)} /> : null}
    </>
  );
};

export const PortalDropdownMenu = ({ buttonLabel, children, size = 'xs', className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({top: 0, right: 0});
  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    const viewportWidth = $(window).width();
    const reversedX = viewportWidth - e.clientX; // Reverse X coordinate
    const rect = e.currentTarget.getBoundingClientRect();

    setPosition({top:`${rect.bottom + window.scrollY}px`, right: `${reversedX}px`});
    setIsOpen((prevState) => !prevState);
  };

  const isModalOpen = () => {
    return $('.modal:visible').length > 0; // Check if any modal is visible
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      if (!isModalOpen()) {
        setIsOpen(false);
      }
    }
  };

  const renderDropdown = () => {
    return ReactDOM.createPortal(
      <ul className={`dropdown-menu dropdown-menu-right ${className} ${isOpen ? 'show' : ''}`} ref={dropdownRef} style={{ position: 'absolute', ...position }}>
        {children}
      </ul>,
      document.body
    );
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {window.addEventListener('click', handleClickOutside)}, 0);
    } else {
      window.removeEventListener('click', handleClickOutside);
    }
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className='dropdown'>
        <button className={`btn btn-${size} btn-default dropdown-toggle}`} onClick={toggleDropdown}>
            {buttonLabel}
        </button>
        {isOpen && renderDropdown()}
    </div>
  );
};

export default Portal;
